import { z } from 'zod'
import { dateOrIsoString } from '~/prix/types/date'
import { enumerated } from '~/prix/types/enumerated'
import sql from '~/prix/utils/sql'
import { bullObject } from '../bull/bullObject'
import { numericValue } from '../heavyMachinery/heavyMachineryObject'

export const semenStockType = enumerated({
  entry: 'Entrada',
  exit: 'Saída',
})
export const semenType = enumerated({
  conventional: 'Convencional',
  sexed: 'Sexado',
  genomic: 'Genômico',
})

export const semenStockObject = z.object({
  id: z.string().uuid(),
  bullId: bullObject.shape.id,
  quantity: z.number().int(),
  type: semenStockType,
  buyDate: dateOrIsoString().nullish(),
  noteNumber: z.string().nullish(),
  supplier: z.string().nullish(),
  semenType: semenType.nullish(),
  semenBatchId: z.string().uuid().nullish(),
  unityValue: numericValue.nullish(),
  clientId: z.number().int().nullish(),
  insertUserId: z.string().nullish(),
  editUserId: z.string().nullish(),
  sourceFilter: z.string().nullish(),
  createdAt: dateOrIsoString().nullish(),
  updatedAt: dateOrIsoString().nullish(),
  deletedAt: dateOrIsoString().nullish(),
})

export type SemenStockType = z.infer<typeof semenStockObject>

export const propertyMap = {
  id: sql`id`,
  bullId: sql`bull_id`,
  quantity: sql`quantity`,
  type: sql`type`,
  buyDate: sql`buy_date`,
  noteNumber: sql`note_number`,
  supplier: sql`supplier`,
  semenType: sql`semen_type`,
  semenBatchId: sql`semen_batch_id`,
  unityValue: sql`unity_value`,
  sourceFilter: sql`semen_stock.source_filter`,
  clientId: sql`client_id`,
  insertUserId: sql`insert_user_id`,
  editUserId: sql`edit_user_id`,
  createdAt: sql`created_at`,
  updatedAt: sql`updated_at`,
  deletedAt: sql`deleted_at`,
}
